import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiDocumentText, HiLightBulb } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import EnhancedDocumentTracker from '../components/tracker/EnhancedDocumentTracker';

const Documents = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiDocumentText}>
        {t('documents.title')}
      </SectionTitle>

      {/* Enhanced Document Tracker */}
      <EnhancedDocumentTracker />

      {/* Organization tips */}
      <section>
        <SectionTitle level={2} icon={HiLightBulb}>{t('documents.tipsTitle')}</SectionTitle>
        <ul className="space-y-2">
          {t('documents.tipsItems', { returnObjects: true }).map((item, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="text-teal-600 dark:text-teal-400 flex-shrink-0 mt-1">•</span>
              <span className="text-gray-700 dark:text-gray-300">{item}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* Good reflex reminder */}
      <InfoBox type="reflexe" title={t('home.goodReflexTitle')}>
        <p>{t('home.goodReflexContent')}</p>
      </InfoBox>

      {/* Loss reminder */}
      <InfoBox type="conseil" title={t('civilFamily.lossTitle')}>
        <p>{t('civilFamily.lossContent')}</p>
      </InfoBox>
    </div>
  );
};

export default Documents;
